import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function Checkbox(props) {
  const { height, width, backgroundColor, iconColor } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="2" fill={backgroundColor} />
      <path
        d="M9.33333 17.8667L4 12.5333L5.86667 10.6667L9.33333 14.1333L18.1333 5.33333L20 7.2L9.33333 17.8667Z"
        fill={iconColor}
      />
    </svg>
  );
}

Checkbox.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  backgroundColor: PropTypes.string,
  iconColor: PropTypes.string
};

Checkbox.defaultProps = {
  height: 13.5,
  width: 13.5,
  backgroundColor: colors.colorBlue,
  iconColor: colors.colorWhite
};

export default Checkbox;
